export default "__VITE_ASSET__E92AJsoS__"